export const projectsBg = require('images/projects/projectsBg.webp');
export const cableDesign = require('images/projects/cableDesign.webp');
export const cableDesign1 = require('images/projects/cableDesign1.webp');
export const cableDesign2 = require('images/projects/cableDesign2.webp');
export const cableDesign3 = require('images/projects/cableDesign3.webp');
export const wirelessCom1 = require('images/projects/wirelessCom1.webp');
export const wirelessCom2 = require('images/projects/wirelessCom2.webp');
export const wirelessCom3 = require('images/projects/wirelessCom3.webp');
export const wirelessCommunicationBg = require('images/projects/wirelessCommunicationBg.webp');
export const projectsEnergy1 = require('images/projects/projectsEnergy1.webp');
export const projectsEnergy2 = require('images/projects/projectsEnergy2.webp');
export const projectsEnergy3 = require('images/projects/projectsEnergy3.webp');
export const projectEngineering1 = require('images/projects/projectEngineering1.webp');
export const projectEngineering2 = require('images/projects/projectEngineering2.webp');
export const projectEngineering3 = require('images/projects/projectEngineering3.webp');
export const projectTechnologyDeployment1 = require('images/projects/projectTechnologyDeployment1.webp');
export const projectTechnologyDeployment2 = require('images/projects/projectTechnologyDeployment2.webp');
export const projectTechnologyDeployment3 = require('images/projects/projectTechnologyDeployment3.webp');
export const construction = require('images/projects/construction.webp');
export const energy = require('images/projects/energy.webp');
export const engineering = require('images/projects/engineering.webp');
export const technology = require('images/projects/technology.webp');
export const wireless = require('images/projects/wireless.webp');
export const projectEnergyBg = require('images/projects/projectEnergyBg.webp');
export const projectEngeneeringBg = require('images/projects/projectEngeneeringBg.webp');
export const technologyDeploymentBg = require('images/projects/technologyDeploymentBg.webp');
